import { useEffect, useState } from "react";
import { Formik, useFormik } from "formik";
import { NotificationManager } from "react-notifications";
import * as yup from "yup";
import { addRole } from "app/services/roleService";
import { RenderTextArea, RenderTextInput } from "app/common/renderInput";

const validationModel = yup.object().shape({
  roleName: yup.string().required("Please enter role"),
  description: yup.string().optional(),
  isLocked: yup.boolean().required(),
});

const CreateRoles = (props) => {
  const [initialValues, setInitialValues] = useState({
    roleName: "",
    description: "",
    isLocked: false,
  });

  const handleSubmit = async (values, { resetForm }) => {
    const response = await addRole(values);
    console.log(response);
    if (response.status === "Success") {
      NotificationManager.success(response.message);
      document.getElementsByClassName("btn-close")[0].click();
      props.loadRoles();

      resetForm();
    } else {
      NotificationManager.error(response.message);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema: validationModel,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  });

  return (
    <>
      <div
        className="modal fade"
        id="createRoleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        data-backdrop="static"
        data-keyboard="false"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <form
              className="needs-validation"
              onSubmit={formik.handleSubmit}
              noValidate
            >
              <div className="modal-header m-0">
                <h5 className="modal-title" id="exampleModalLabel">
                  Create Role
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <RenderTextInput
                  type="text"
                  name="roleName"
                  display="Role"
                  value={formik.values.roleName}
                  error={formik.errors.roleName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  touched={formik.touched.roleName}
                  required
                />

                <RenderTextArea
                  name="description"
                  display="Description"
                  value={formik.values.description}
                  error={formik.errors.description}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  touched={formik.touched.description}
                />
                <div className="ml-3">
                  <div className="form-check form-switch">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="flexSwitchCheckChecked"
                      name="isLocked"
                      checked={formik.values.isLocked}
                      onChange={formik.handleChange}
                    />
                    <label
                      className="form-check-label"
                      htmlFor="flexSwitchCheckChecked"
                    >
                      Lock
                    </label>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-primary">
                  Save changes
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateRoles;
